module.exports = __webpack_public_path__ + "media/images/Bora bora-c17b4181aeb5c18ed1b7f99449ca200f.svg";